
export const setReserves = (state, reserves) => {
    state.reserves = reserves
    state.loading = false
}

export const setCurrentReserve = (state, reserve) => {
    state.currentReserve = reserve
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
